import { useMutation } from "react-query";
import { TServiceValuationForm } from "../../apps/affinity/pages/ServicePage/components/ServiceValuation/types";
import { queryClient } from "../../lib/react-query";
import { apiEmpleo } from "../../util/ApiEmpleo";

export default function useSaveAndExitMutation() {
  const saveAndExit = async ({
    serviceId,
    formData,
    valuationNotes,
  }: {
    serviceId: string;
    formData: TServiceValuationForm;
    valuationNotes: string;
  }) => {
    const data = {
      valuationData: formData,
      notesDuringValuation: valuationNotes,
    };

    await apiEmpleo.patch(`services/${serviceId}`, data, {
      headers: {
        "Content-Type": "application/merge-patch+json",
      },
    });
  };

  return useMutation(saveAndExit, {
    onMutate: ({ serviceId, formData }) => {
      queryClient.cancelQueries(["service", serviceId]);
      queryClient.cancelQueries(["services"]);
    },
    onError: () => {},
    onSettled: (data, error, { serviceId, formData }) => {
      queryClient.invalidateQueries(["service", serviceId]);
      queryClient.invalidateQueries(["services"]);
    },
  });
}
